import request from '@/utils/request';

export function listSatisfaction(accidentId: string) {
  return request({
    url: '/bak/followup/satisfaction/list/',
    method: 'get',
    params: {accidentId}
  });
}

export function sendSatisfaction(accidentId, phone) {
  return request({
    url: '/bak/followup/satisfaction/send/',
    method: 'post',
    params: {accidentId, phone}
  });
}
